import React, {useState} from 'react';
import Select from 'react-select';
import {useIntl} from 'react-intl';
import {shumaStatuses} from '../../constants/options';
import {commonStyles} from '../../selectStyles/customSelectStyles';
import ModalContainer from '../ModalContainer';
import ModalHeader from '../ModalHeader';
import ButtonAction from '../ButtonAction';
import ModalContent from '../ModalContent';
import ModalButtonsContainer from '../ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../styles/styles';

const StatusBadge = ({status, onChange, onSubmit, size = 'sm'}) => {
  const intl = useIntl();

  const getBgColor = () => {
    switch (status.value) {
      case 3:
        return 'rgb(179, 143, 105)';
      case 4:
        return '#E3F0FB';
      case 5:
        return '#CDEADB';
      case 6:
        return 'rgb(211, 177, 216)';
      case 7:
        return 'rgb(233, 236, 236)';
      case 8:
        return 'rgb(148, 153, 188)';
      case 9:
        return '#000';
      case 10:
        return '#F2E6E6';
      case 1:
      default:
        return '#F9F4E5';
    }
  };
  const getTextColor = () => {
    switch (status.value) {
      case 3:
        return 'rgb(239, 225, 205)';
      case 4:
        return 'rgb(56, 189, 248)';
      case 5:
        return 'rgb(65, 141, 88)';
      case 6:
        return 'rgb(136, 73, 144)';
      case 7:
        return 'rgb(82, 94, 96)';
      case 8:
        return 'rgb(29, 31, 46)';
      case 9:
        return 'rgb(255, 255, 255)';
      case 10:
        return 'rgb(239, 65, 48)';
      case 1:
      default:
        return 'rgb(253, 185, 19)';
    }
  };

  const styles = {
    fontWeight: 500,
    border: '1px solid ' + getTextColor(),
    backgroundColor: getBgColor(),
    width: size === 'sm' ? '150px' : '200px',
    color: getTextColor(),
    borderRadius: '9999px',
    fontSize: size === 'sm' ? '18px' : '24px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: size === 'sm' ? 0 : '0.5rem',
  };

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <div
        onClick={handleShow}
        style={styles}
      >
        {status?.label}
      </div>
      <ModalContainer show={show} size={'md'} onHide={handleClose}>
        <ModalHeader header={intl.formatMessage({
          id: 'inspections-edit-inspection-status',
          defaultMessage: 'Edit inspections status'
        })}/>
        <ModalContent customClassnames={'bg-transparent px-20'}>
          <Select
            name={'status'}
            options={shumaStatuses}
            value={status}
            styles={commonStyles}
            isSearchable={true}
            isAsync={true}
            onChange={onChange}
          />
        </ModalContent>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={handleClose}
            label={intl.formatMessage({id: 'button-cancel', defaultMessage: 'Cancel'})}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            onClick={() => {
              onSubmit();
              handleClose();
            }}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={intl.formatMessage({id: 'button-submit', defaultMessage: 'Submit'})}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default StatusBadge;